export default {
  direct: 'Diretto',
  stops: 'scali',
  stop: 'scala',
}
